import {
  COLORS,
  CustomTypographyProps,
  SayIcon,
} from "@asayinc/component-library";

import styles from "./SortCell.module.css";
import { useSort } from "../../utils";
import { TextCell } from "../TextCell";
import { ReactNode } from "react";

interface Props extends CustomTypographyProps {
  sortKey: string;
  children: ReactNode;
}

export const SortCell = ({ sortKey, children, ...props }: Props) => {
  const [activeSortKey, setActiveSortKey] = useSort();

  const sortIcon = (() => {
    switch (activeSortKey) {
      case sortKey:
        return (
          <SayIcon name="ChevronDown" size="10" color={COLORS.DARK_HOVER} />
        );
      case `-${sortKey}`:
        return <SayIcon name="ChevronUp" size="10" color={COLORS.DARK_HOVER} />;
      default:
        return (
          <div className={styles.idleSortIcon}>
            <SayIcon name="ChevronDown" size="10" color={COLORS.DARK_HOVER} />
          </div>
        );
    }
  })();

  const sortClicked = () => {
    setActiveSortKey((prevSort) => {
      if (prevSort === sortKey) {
        return `-${sortKey}`;
      }

      return sortKey;
    });
  };

  return (
    <div className={styles.container} onClick={sortClicked}>
      <TextCell {...props}>{children}</TextCell>
      {sortIcon}
    </div>
  );
};
